// Pre-filled workflow JSON examples to onboard users without making them
// learn the full schema from scratch.

export const TEMPLATE_INBOUND_ROUTING = {
  nodes: [
    { id: "start", type: "start", data: {} },
    {
      id: "check_hours",
      type: "if_time",
      data: {
        operator: "between",
        from: "09:00",
        to: "17:00",
        days: ["mon", "tue", "wed", "thu", "fri"],
        timezone: "America/Los_Angeles",
      },
    },
    {
      id: "forward",
      type: "forward_call",
      data: { number: "+15551234567" },
    },
    { id: "end_yes", type: "end", data: {} },
    { id: "end_no", type: "end", data: {} },
  ],
  edges: [
    { source: "start", target: "check_hours" },
    { source: "check_hours", target: "forward", source_handle: "yes" },
    { source: "forward", target: "end_yes" },
    { source: "check_hours", target: "end_no", source_handle: "no" },
  ],
};

export const TEMPLATE_BOOKING_REMINDERS = {
  nodes: [
    { id: "start", type: "start", data: {} },
    {
      id: "wait_24h",
      type: "wait_until_event_offset",
      data: { event_field: "booking_time", offset_seconds: -86400 },
    },
    {
      id: "sms_confirm",
      type: "send_sms",
      data: {
        link_tool_user_id: "REPLACE_WITH_TWILIO_SMS_LINK_TOOL_USER_ID",
        to: "{{phone}}",
        message:
          "Hi! This is a reminder that your appointment is on {{appointment_date}} at {{appointment_time}}. Reply YES to confirm.",
      },
    },
    {
      id: "wait_1h",
      type: "wait_until_event_offset",
      data: { event_field: "booking_time", offset_seconds: -3600 },
    },
    {
      id: "sms_remind",
      type: "send_sms",
      data: {
        link_tool_user_id: "REPLACE_WITH_TWILIO_SMS_LINK_TOOL_USER_ID",
        to: "{{phone}}",
        message:
          "Your appointment is starting in 1 hour. See you at {{appointment_time}}!",
      },
    },
    { id: "end", type: "end", data: {} },
  ],
  edges: [
    { source: "start", target: "wait_24h" },
    { source: "wait_24h", target: "sms_confirm" },
    { source: "sms_confirm", target: "wait_1h" },
    { source: "wait_1h", target: "sms_remind" },
    { source: "sms_remind", target: "end" },
  ],
};

export const TRIGGER_LABELS = {
  inbound_call: "Inbound Call",
  inbound_chat: "Inbound Chat",
  booking_created: "Booking Created",
  booking_missed: "Booking Missed",
  manual: "Manual",
};

export const STATUS_COLOR = {
  active: "green",
  paused: "gray",
};

export const RUN_STATUS_COLOR = {
  running: "blue",
  waiting: "yellow",
  done: "green",
  failed: "red",
  cancelled: "gray",
};

export const STEP_STATUS_COLOR = {
  running: "blue",
  done: "green",
  failed: "red",
  skipped: "gray",
};
